exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fade-alert-enter-active[data-v-787d9900],.fade-alert-leave-active[data-v-787d9900]{transition:opacity .5s\n}\n.fade-alert-enter[data-v-787d9900],.fade-alert-leave-to[data-v-787d9900]{opacity:0\n}", ""]);

// exports
